import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FiltersControls, Pagination, Spinner, BoxList, Modal } from 'components';

import {
  loadIpmaRegOfficeCoursesCreator,
  setIpmaRegOfficeCoursesPageCreator,
  setIpmaRegOfficeCoursesPerPageCreator,
  acceptIpmaRegOfficeCourseCreator,
  rejectIpmaRegOfficeCourseCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';
import { CourseButtonAction, Flex } from '../CoursesProgrammes.styled';
import UploadModal from '../UploadModal/UploadModal';
import AcceptModal from '../AcceptModal/AcceptModal';

const Waiting = ({
  courses,
  page,
  pages,
  perPage,
  loading,
  loadCourses,
  setPage,
  setPerPage,
  cancelCourse,
}) => {
  const { t } = useTranslation();
  const [cancelModal, setCancelModal] = useState(0);
  const [acceptModal, setAcceptModal] = useState(0);
  const [uploadModal, setUploadModal] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);

  useEffect(() => {
    setPage(1);
  }, [perPage]);

  useEffect(() => {
    loadCourses({ status: 'pending' });
  }, [perPage, page]);

  const submitCancel = () => {
    cancelCourse({ id: cancelModal, type: 'pending' });
    setCancelModal(0);
  };

  return (
    <>
      <FiltersControls
        perPageSelected={perPage}
        perPageOnChange={({ value }) => setPerPage(value)}
      />
      {loading ? <Spinner /> : null}
      {!loading ? (
        <>
          <BoxList
            type="course"
            items={courses}
            alert={t('global.noResultsFound')}
            customRenderActions={({ item }) => (
              <Flex>
                <CourseButtonAction
                  icon="checkCircle"
                  title={t('global.acceptButton')}
                  verticalviewbreakpoint="xl"
                  disabled={!item.regLogoZipFile && !item.googleFileUrl}
                  onClick={() => setAcceptModal(item)}
                />
                <CourseButtonAction
                  icon="closeCircle"
                  title={t('global.rejectButton')}
                  verticalviewbreakpoint="xl"
                  onClick={() => setCancelModal(item.id)}
                />
                <CourseButtonAction
                  icon="upload"
                  title={t('global.uploadEditRegLogo')}
                  verticalviewbreakpoint="xl"
                  onClick={() => setUploadModal(item.id)}
                  fullWidth
                />
              </Flex>
            )}
          />
          <Pagination styled currentPage={page} totalPages={pages} onChange={setPage} />
        </>
      ) : null}
      <AcceptModal status="pending" open={acceptModal} setOpen={setAcceptModal} />
      <Modal
        heading={t('page.ipma.office.cancelCourse')}
        description={t('page.ipma.office.cancelCourseDesc')}
        isOpen={!!cancelModal}
        confirm={submitCancel}
        cancel={() => setCancelModal(0)}
      />
      <UploadModal
        files={filesToUpload}
        open={uploadModal}
        status="pending"
        setFiles={setFilesToUpload}
        setOpen={setUploadModal}
      />
    </>
  );
};

Waiting.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  loadCourses: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  cancelCourse: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ipma, loading }) => ({
  courses: ipma.regOfficeCourses.list.items,
  page: ipma.regOfficeCourses.list.page,
  pages: ipma.regOfficeCourses.list.pages,
  perPage: ipma.regOfficeCourses.list.perPage,
  loading: isLoading(loading, 'IPMA'),
});
const mapDispatchToProps = (dispatch) => ({
  loadCourses: (payload) => dispatch(loadIpmaRegOfficeCoursesCreator(payload)),
  setPage: (payload) => dispatch(setIpmaRegOfficeCoursesPageCreator(payload)),
  setPerPage: (payload) => dispatch(setIpmaRegOfficeCoursesPerPageCreator(payload)),
  cancelCourse: (payload) => dispatch(rejectIpmaRegOfficeCourseCreator(payload)),
  acceptCourse: (payload) => dispatch(acceptIpmaRegOfficeCourseCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Waiting);
